import { AvailableWidget } from "ui/components/Grid/types";
import { CalculationDetail } from "services/api/calculations/types";
import CalculationVehicleCard from "./components/CalculationVehicleCard/CalculationVehicleCard";
import CalculationBreakdownCard from "./components/CalculationBreakdownCard/CalculationBreakdownCard";

// Widgeti za grid prikaz detalja kalkulacije: lijevo vozilo, desno razrada cijene.
export const CALCULATION_DETAIL_WIDGETS = (
  calculation: CalculationDetail
): AvailableWidget[] => [
  {
    id: "widget-calculation-vehicle",
    name: "Informacije o vozilu",
    icon: "info",
    header: <></>,
    component: <CalculationVehicleCard calculation={calculation} />,
  },
  {
    id: "widget-calculation-breakdown",
    name: "Razrada cijene",
    icon: "calculator",
    header: <></>,
    component: <CalculationBreakdownCard calculation={calculation} />,
  },
];
